import EliminatoriaCompartida from "./EliminatoriaCompartida";

const DieciseisAvos = () => (
  <EliminatoriaCompartida
    fase="dieciseisavos"
    titulo="Predicciones 16avos de Final"
    endpoint="/dieciseis/partidos"
    fechaPrimerPartido="2026-07-04T12:00:00"
  />
);

export default DieciseisAvos;
